/* eslint-disable @next/next/no-img-element */
"use client";

import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { useGlobalData } from "@/contexts/GlobalData";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { cn } from "@/lib/utils";
import { width } from "@amcharts/amcharts4/.internal/core/utils/Utils";
import DynamicFontSize from "../DynamicFontSize";
import DynamicSizeIcon from "../DynamicSizeIcon";
interface ModalLayoutPropsType extends GeneralPropsType {
  title?: React.ReactNode;
  onClose?: (data?: any) => any;
  childrenClassName?: string;
  headerClassName?: string;
  boxClassName?: string;
  disabledBackground?: boolean;
  modalKey: string;
  hideOutsideClick?: boolean;
  id?: string;
  hideCloseButton?: boolean;
  style?: React.CSSProperties;
  boxStyle?: React.CSSProperties;
}
function ModalLayout({
  title,
  onClose,
  children,
  className,
  childrenClassName,
  headerClassName,
  boxClassName,
  disabledBackground,
  modalKey,
  hideOutsideClick,
  id,
  onClick,
  hideCloseButton,
  style,
  boxStyle
}: ModalLayoutPropsType) {
  const {
    getIcon,
    routeSetting,
    screenSize,
    isLimitSize
  } = useGlobalData();
  const router = useRouter();
  useEffect(() => {
    console.log("🚀🚀🚀🚀🚀🚀🚀 ~ modalKey: ", modalKey);
  }, []);
  useEffect(() => {
    try {
      if (!modalKey || !routeSetting || !routeSetting[modalKey] || !routeSetting[modalKey]?.targetPath || !routeSetting[modalKey]?.timeout) return;
      const tm = setTimeout(() => {
        router.push(routeSetting[modalKey]?.targetPath);
        console.log("🚀 ~ tm ~ targetPath:", routeSetting[modalKey]?.targetPath);
        clearTimeout(tm);
      }, routeSetting[modalKey]?.timeout);
    } catch (err) {
      console.log("🚀 ~ useEffect ~ err:", err);
    }
  }, [modalKey, routeSetting]);
  return <div className={clsx("bg-cover bg-no-repeat relative z-[9999] min-h-[100dvh] flex flex-col", styles.container, className)} id={id} onClick={onClick} style={style} data-sentry-component="ModalLayout" data-sentry-source-file="index.tsx">
            {!hideOutsideClick && <div className="flex-1 w-full" onClick={onClose}></div>}
            <div className={clsx("py-4 flex flex-col pb-12 border-t-2 border-t-secondary rounded-3xl !max-h-[100dvh] !bg-cover !bg-bottom !bg-no-repeat mx-auto", boxClassName)} style={{
      width: isLimitSize ? screenSize?.realWidth : "100%",
      ...(disabledBackground ? {} : {
        background: `url(images/main_bg.jpg)`
      }),
      maxHeight: `${boxStyle?.maxHeight} !important`,
      ...boxStyle
    }}>
                <div className={clsx("flex items-center justify-between px-4 gap-4", headerClassName)}>
                    <DynamicFontSize className={styles.title} fontSize={18} data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                        {title}
                    </DynamicFontSize>
                    {!hideCloseButton && <DynamicSizeIcon icon={getIcon("close_modal")} width={24} onClick={onClose} className="cursor-pointer" />}
                </div>
                <div className={clsx("divider m-4")}></div>
                <div className={cn("flex-1 overflow-y-auto overflow-x-hidden px-4", childrenClassName)}>{children}</div>
            </div>
        </div>;
}
export default ModalLayout;